/* istanbul ignore file */

import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DOCUMENT, inject, signal, WritableSignal, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent, ExpanderComponent } from '@libs/common/components';
import { TextComponent } from '@libs/form/components';
import { TextInputModel } from '@libs/form/models';
import { DataLayerItem } from '@libs/shop/models';

@Component({
  selector: 'ui-tracking-debugger',
  imports: [JsonPipe, ButtonComponent, ExpanderComponent, TextComponent, ReactiveFormsModule],
  templateUrl: './tracking-debugger.component.html',
  styleUrl: './tracking-debugger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingDebuggerComponent implements OnInit {
  public document: Document = inject(DOCUMENT);
  public filterControl: FormControl<string> = new FormControl<string>('', { nonNullable: true });
  public filterData: TextInputModel = {
    type: 'text',
    name: 'filter',
    label: 'Filter',
  };

  public dataLayer: WritableSignal<DataLayerItem[]> = signal([]);
  public currentFilter: WritableSignal<string> = signal('');

  public constructor() {
    this.filterControl.valueChanges.pipe(takeUntilDestroyed()).subscribe(value => {
      this.currentFilter.set(value);
      this.fillDataLayer(value);
    });
  }

  public ngOnInit(): void {
    this.fillDataLayer();
  }

  public fillDataLayer(filter: string | undefined = undefined): void {
    const dataLayer: DataLayerItem[] = this.document.defaultView?.dataLayer?.concat().reverse() ?? [];

    if (!filter) {
      this.dataLayer.set(dataLayer.filter(x => !JSON.stringify(x).includes('tracking-debugger')));
    } else {
      this.dataLayer.set(dataLayer.filter(x => {
        const json: string = JSON.stringify(x);

        return !json.includes('tracking-debugger') && json.includes(filter);
      }));
    }
  }

  public clearDataLayer(): void {
    if (this.document.defaultView) {
      this.document.defaultView.dataLayer = [];
    }
    
    this.fillDataLayer();
  }
}
